import { render, staticRenderFns } from "./regra-reserva-semanas-do-mes.vue?vue&type=template&id=1300660c&scoped=true"
import script from "./regra-reserva-semanas-do-mes.vue?vue&type=script&lang=ts"
export * from "./regra-reserva-semanas-do-mes.vue?vue&type=script&lang=ts"
import style0 from "./regra-reserva-semanas-do-mes.vue?vue&type=style&index=0&id=1300660c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1300660c",
  null
  
)

export default component.exports